import { gateway } from "../../../gateway";
import { IRollSigningSecretResponse } from "../interfaces";

export const rollEventDeliverySigningSecret = async (): Promise<IRollSigningSecretResponse> => {
  const response = await gateway.post("/event-delivery/config/signing-secret/roll");
  return response?.data?.data;
};
